import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import s from '../ModalsStyle.module.scss';
import { t } from '../../../i18n';

const ErrorExtension = ({ onHide, show }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      contentClassName={s.defaultModal}
      centered
    >
      <Modal.Body>
        <div className="d-flex flex-column align-items-center justify-content-space-around">
          <span className={s.modalText}>
            {t(
              'Only files that had been created with CROSSLOAD#xplain can be opened!'
            )}
          </span>
          <div className={s.modalButtons}>
            <Button
              variant="warning"
              onMouseDown={(e) => {
                e.preventDefault();
                onHide();
              }}
              className="btn-square btn-sm btn-default"
            >
              {t('OK').toUpperCase()}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorExtension;
